import { AnyAction } from 'redux';
import { concat, uniqBy, orderBy } from 'lodash';
import { PlaceholderManagementType } from './placeholder.types';
import { DynamicColumn, IdNameOption, MultiDynamicColumnMaster, PlaceholderCardItem, PlaceholderFilterValues, PlaceholderIndividualDetail } from '../types';

export interface PlaceholderDetailsState {
  category1: IdNameOption[];
  category2: IdNameOption[];
  brands: IdNameOption[];
  seasons: IdNameOption[];
  dynamicColumn: DynamicColumn[];
  multiCustomAttribute: MultiDynamicColumnMaster[];
  productType: IdNameOption[];
  placeholderList: PlaceholderCardItem[];
  supplierType: IdNameOption[];
  filterValues: PlaceholderFilterValues;
  searchedProductList: unknown[];
  totalCount: number;
  individualDetail: PlaceholderIndividualDetail | null;
  placeholderCardList: PlaceholderCardItem[];
  productDetail?: unknown;
}

const initialState: PlaceholderDetailsState = {
  category1: [],
  category2: [],
  brands: [],
  seasons: [],
  dynamicColumn: [],
  multiCustomAttribute: [],
  productType: [],
  placeholderList: [],
  supplierType: [],
  filterValues: {
    selectedSeason: [],
    selectedYear: [],
    selectedBrand: [],
    category1: [],
    category2: [],
    category3: [],
    category4: [],
    selectedMonth: [],
    selectedProductType: [],
    productDetail: [],
  },
  searchedProductList: [],
  totalCount: 0,
  individualDetail: null,
  placeholderCardList: [],
};

const PlaceholderManagementReducer = (state: PlaceholderDetailsState = initialState, action: AnyAction): PlaceholderDetailsState => {
  switch (action.type) {
    case PlaceholderManagementType.CATEGORY1:
      return {
        ...state,
        category1: action.payload,
      };
    case PlaceholderManagementType.CATEGORY2:
      return {
        ...state,
        category2: action.payload,
      };

    case PlaceholderManagementType.BRANDS:
      return {
        ...state,
        brands: action.payload,
      };
    case PlaceholderManagementType.SEASONS:
      return {
        ...state,
        seasons: action.payload,
      };
    case PlaceholderManagementType.DYNAMIC_COLUMN:
      return {
        ...state,
        dynamicColumn: action.payload,
      };
    case PlaceholderManagementType.MULTI_DYNAMIC_COLUMN:
      return {
        ...state,
        multiCustomAttribute: action.payload,
      };
    case PlaceholderManagementType.PRODUCT_TYPE:
      return {
        ...state,
        productType: action.payload,
      };
    case PlaceholderManagementType.PLACEHOLDER_DATA:
      return {
        ...state,
        placeholderList: orderBy(uniqBy(concat(action.payload.response, state.placeholderList), '_id'), ['createdAt'], ['desc']),
        totalCount: action.payload.totalCount,
      };
    case PlaceholderManagementType.SET_FILTER_SORT_DATA:
      return {
        ...state,
        filterValues: { ...state.filterValues, ...action.payload },
      };
    case PlaceholderManagementType.SUPPLIERTYPE:
      return {
        ...state,
        supplierType: action.payload,
      };
    case PlaceholderManagementType.PRODUCT_DETAIL:
      return {
        ...state,
        productDetail: action.payload,
      };
    case PlaceholderManagementType.SEARCHED_PRODUCTS:
      return {
        ...state,
        searchedProductList: action.payload,
      };
    case PlaceholderManagementType.CLEAR_REDUCER:
      return {
        ...state,
        placeholderList: [],
        totalCount: 0,
      };
    case PlaceholderManagementType.SET_INDIVIDUAL_DETAILS:
      return {
        ...state,
        individualDetail: action.payload,
      };
    case PlaceholderManagementType.GET_PLACEHOLDER_CARD_DATA: {
      const incomingCards = action.payload?.response || [];
      const isFirstPage = (action.payload?.pageIndex ?? 1) <= 1;
      return {
        ...state,
        placeholderCardList: isFirstPage ? incomingCards : uniqBy(concat(state.placeholderCardList, incomingCards), '_id'),
        totalCount: action.payload?.totalCount || 0,
      };
    }
    case PlaceholderManagementType.DELETE_PLACEHOLDER_DATA:
      return {
        ...state,
        placeholderCardList: action.payload?.response || [],
      };
    case PlaceholderManagementType.CLEAR_INDIVIDUAL_REDUCER:
      return {
        ...state,
        individualDetail: null,
      };
    default:
      return state;
  }
};

export default PlaceholderManagementReducer;
